export default __webpack_public_path__ + "static/1-f73bca3b94688451591dcbc8541a2f5a.png";